import $store from '@/store'

/**
 * 状态类
 */
export default class CommonState {
  constructor(code, chineseName, englishName, children = null, selected = false) {
    this.code = code
    this.chineseName = chineseName
    this.englishName = englishName
    this.children = children
    this.selected = selected
  }
}

// export const commonStateClass = CommonState // 原有下拉框code是int,会解析为字符串。先注掉了
/**
 * 根据code查询list中的State索引
 */
export function getStateIndexByCode(list, code, dataField = 'code') {
  let result = null
  for (const state of list) {
    if (state[dataField] === code) {
      result = state
    }
  }
  return result
}

/**
 * 根据code查询list中的State对象
 */
export function getStateByCode(list, code) {
  return getStateIndexByCode(list, code)
}

/**
 * 根据code获取 CommonState 的name
 * @param items
 * @param code
 */
export function getNameByCode(items, code, lang) {
  const valueType = Object.prototype.toString.call(items)
  lang = lang || $store.getters.language
  const filedName = lang === 'zh' ? 'chineseName' : 'englishName'
  let tempItems = []
  switch (valueType) {
    case '[object Array]':
      tempItems = items
      break
    case '[object Set]':
      tempItems = [...items]
      break
    case '[object CommonState]':
      tempItems = [items]
      break
  }
  const findItem = tempItems.find(item => {
    return item.code === code
  })

  return findItem ? findItem[filedName] : ''
}

export function getName(commonState) {
  if (!commonState) {
    return ''
  }
  const filedName = $store.getters.language === 'zh' ? 'chineseName' : 'englishName'
  return commonState[filedName]
}
